import React, { useEffect, useState } from 'react';
import unsplash from '../api/unsplash';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Tooltip,
    Checkbox,
    FormControlLabel,
    Autocomplete,
    Card,
    Grid,
    CardContent,
    Zoom,
    LinearProgress,
    TextField,
    Typography,
} from '@mui/material';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import {
    Circle,
    HideSource,
    Close,
    MoreTime,
    Check,
    Warning,
    Add,
    Remove,
    PictureAsPdf,
} from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatPigrecoCompletionDate } from '../utils/pigrecoDates';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const normalizeTaxCode = (value) =>
    (value || '').toString().trim().toUpperCase();

const normalizeCompany = (value) =>
    (value || '')
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]/gi, '');

const pickLavoratoreDetails = (lavoratoriByCf, partecipante) => {
    const normalizedCf = normalizeTaxCode(partecipante?.taxcode);
    if (!normalizedCf) {
        return undefined;
    }

    const matches = lavoratoriByCf.get(normalizedCf) || [];
    if (matches.length <= 1) {
        return matches[0];
    }

    const normalizedCompany = normalizeCompany(partecipante?.custom_b);
    if (!normalizedCompany) {
        return matches[0];
    }

    const companyMatches = matches.filter(
        (lavoratore) =>
            normalizeCompany(lavoratore?.RagioneSociale) === normalizedCompany
    );

    return companyMatches[0] || matches[0];
};

const statusFilterKeys = ['completati', 'nonCompletati', 'termineScaduto'];

const hasActiveStatusFilter = (filterValue) =>
    statusFilterKeys.some((key) => filterValue[key]);

const normalizeStatusFilters = (filterValue) => {
    if (hasActiveStatusFilter(filterValue)) {
        return filterValue;
    }

    return {
        ...filterValue,
        completati: true,
        nonCompletati: true,
        termineScaduto: true,
    };
};

const AndamentoELearning = () => {
    const [scadenzeCorsi, setScadenzeCorsi] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scadenzeCorsiBackup, setScadenzeCorsiBackup] = useState([]);
    const [filtro, setFiltro] = useState({
        completati: true,
        nonCompletati: true,
        termineScaduto: true,
        inScadenza: false,
    });
    const [includiCessati, setIncludiCessati] = useState(false);
    const [giorniInScadenza, setGiorniInScadenza] = useState(10);
    const [corsi, setCorsi] = useState([]);
    const [corsiSel, setCorsiSel] = useState('');
    const [corsoSel, setCorsoSel] = useState(null);
    const [selectionModel, setSelectionModel] = useState([]);
    const [bulkExtraDaysOpen, setBulkExtraDaysOpen] = useState(false);
    const [bulkExtraDaysLoading, setBulkExtraDaysLoading] = useState(false);
    const [bulkExtraDaysResult, setBulkExtraDaysResult] = useState(null);
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const columns = [
        {
            field: '*',
            headerName: 'Azioni',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (el) => (
                <PopUpGiorniCorsi
                    row={el.row}
                    statusOfCourse={statusOfCourse}
                    corso={corsoSel}
                    handleShowSnack={handleShowSnack}
                />
            ),
        },
        {
            headerName: 'Corso',
            field: 'corso',
            width: 100,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'custom_b',
            headerName: 'Azienda',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'surname',
            headerName: 'Cognome',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'name',
            headerName: 'Nome',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Matricola',
            headerName: 'Matricola',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Qualifica',
            headerName: 'Qualifica',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Sesso',
            headerName: 'Sesso',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'date_subscribe',
            headerName: 'Data Iscrizione',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (row) => moment(row.value).format('DD/MM/YYYY'),
        },
        {
            field: 'date_start',
            headerName: 'Data Inizio',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (row) =>
                row.value ? moment(row.value).format('DD/MM/YYYY') : '-',
        },
        {
            field: 'date_end',
            headerName: 'Data Completamento',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (row) => formatPigrecoCompletionDate(row.value),
        },
        {
            field: 'date_expire',
            headerName: 'Termine Massimo',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (el) => {
                const expired = isExpired(el.row);

                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5,
                            width: '100%',
                        }}
                    >
                        {el.value ? moment(el.value).format('DD/MM/YYYY') : ''}
                        {expired && (
                            <Warning sx={{ color: '#FF2768!important' }} />
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'perc_course',
            headerName: 'Percentuale Avanzamento',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (el) => (
                <p
                    className={
                        el.row.perc_course <= 33
                            ? 'text-redMiller'
                            : el.row.perc_course <= 66
                              ? 'text-[#2265B1]'
                              : 'text-greenMiller'
                    }
                >
                    {el.row.perc_course + '%'}
                </p>
            ),
            valueGetter: (el) => el.row.perc_course,
        },
    ];

    const isCompleted = (row) => Number(row?.perc_course) === 100;

    const getDeadline = (row) => {
        if (!row?.date_expire) {
            return null;
        }
        const deadline = moment(row.date_expire);
        return deadline.isValid() ? deadline.startOf('day') : null;
    };

    const isExpired = (row) => {
        const deadline = getDeadline(row);
        return (
            !isCompleted(row) &&
            !!deadline &&
            deadline.isBefore(moment().startOf('day'), 'day')
        );
    };

    const selectedRows = scadenzeCorsi.filter((row) =>
        selectionModel.includes(row.id)
    );

    const openBulkExtraDays = () => {
        setBulkExtraDaysResult(null);
        setBulkExtraDaysOpen(true);
    };

    const closeBulkExtraDays = () => {
        if (!bulkExtraDaysLoading) {
            setBulkExtraDaysOpen(false);
            setBulkExtraDaysResult(null);
        }
    };

    const addBulkExtraDays = async (giorni) => {
        setBulkExtraDaysLoading(true);
        try {
            const response = await unsplash.post(
                'pigreco/addDaysEmployees',
                {
                    giorni,
                    corso: corsoSel,
                    iscrizioni: selectedRows.map((row) => ({
                        id: row.id,
                        taxcode: row.taxcode,
                        name: row.name,
                        surname: row.surname,
                    })),
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            const { updated = 0, failed = 0 } = response.data || {};
            handleShowSnack(
                failed
                    ? `${updated} aggiornati, ${failed} non aggiornati`
                    : `Tempo extra aggiunto a ${updated} iscrizioni`,
                failed ? 'warning' : 'success'
            );
            await statusOfCourse(corsoSel, includiCessati);
            if (failed) {
                const failedIds = (response.data?.results || [])
                    .filter((result) => !result.success)
                    .map((result) => result.id);
                setSelectionModel(failedIds);
                setBulkExtraDaysResult(response.data);
            } else {
                setBulkExtraDaysOpen(false);
                setBulkExtraDaysResult(null);
                setSelectionModel([]);
            }
        } catch (error) {
            handleShowSnack(
                [
                    error?.response?.data?.error ||
                        "Errore durante l'aggiunta massiva del tempo extra",
                    error?.response?.data?.operationId
                        ? `ID operazione: ${error.response.data.operationId}`
                        : null,
                ]
                    .filter(Boolean)
                    .join(' · '),
                'error'
            );
        } finally {
            setBulkExtraDaysLoading(false);
        }
    };

    const isExpiringWithin = (row, days) => {
        const deadline = getDeadline(row);
        if (!deadline || isCompleted(row) || isExpired(row)) {
            return false;
        }

        const today = moment().startOf('day');
        return (
            deadline.isSameOrAfter(today, 'day') &&
            deadline.diff(today, 'days') <= days
        );
    };

    const getFilteredRows = (
        rows,
        activeFiltro = filtro,
        activeGiorni = giorniInScadenza
    ) => {
        const normalizedFiltro = normalizeStatusFilters(activeFiltro);
        const safeDays = Math.max(Number(activeGiorni) || 0, 0);

        return rows.filter((row) => {
            if (normalizedFiltro.inScadenza) {
                return isExpiringWithin(row, safeDays);
            }

            const completed = isCompleted(row);
            const expired = isExpired(row);
            const inProgress = !completed && !expired;

            const matchesStatus =
                (completed && normalizedFiltro.completati) ||
                (inProgress && normalizedFiltro.nonCompletati) ||
                (expired && normalizedFiltro.termineScaduto);

            if (!matchesStatus) {
                return false;
            }

            return true;
        });
    };

    const applyFilters = (
        activeFiltro = filtro,
        activeGiorni = giorniInScadenza,
        sourceRows = scadenzeCorsiBackup
    ) => {
        setSelectionModel([]);
        setScadenzeCorsi(
            getFilteredRows(sourceRows, activeFiltro, activeGiorni)
        );
    };

    const updateGiorniInScadenza = (step) => {
        const nextDays = Math.max(giorniInScadenza + step, 0);
        setGiorniInScadenza(nextDays);

        if (filtro.inScadenza) {
            applyFilters(filtro, nextDays);
        }
    };

    const toggleFilter = (key) => {
        const nextFiltro = {
            ...filtro,
            [key]: !filtro[key],
        };

        if (
            statusFilterKeys.includes(key) &&
            statusFilterKeys.every((statusKey) => !nextFiltro[statusKey])
        ) {
            return;
        }

        setFiltro(nextFiltro);
        applyFilters(nextFiltro, giorniInScadenza);
    };

    const renderStatusSemaphore = ({
        filterKey,
        title,
        checkedIcon,
        color,
    }) => {
        return (
            <Tooltip title={title}>
                <Checkbox
                    icon={<HideSource />}
                    checked={normalizeStatusFilters(filtro)[filterKey]}
                    checkedIcon={checkedIcon}
                    sx={{
                        color: `${color}!important`,
                        '&.Mui-checked': {
                            color: `${color}!important`,
                        },
                    }}
                    onClick={() => toggleFilter(filterKey)}
                />
            </Tooltip>
        );
    };

    const getStatusLabel = (row) => {
        if (isCompleted(row)) return 'Completato';
        if (isExpired(row)) return 'Termine scaduto';
        return 'In corso';
    };

    const formatPdfDate = (value) => {
        if (!value) return '-';
        const parsed = moment(value);
        if (!parsed.isValid()) return '-';
        return parsed.format('DD/MM/YYYY');
    };

    const exportPdf = () => {
        if (!corsoSel || scadenzeCorsi.length === 0) {
            handleShowSnack('Non ci sono dati da esportare', 'warning');
            return;
        }

        const selectedCourse = corsi.find((item) => item.Codice === corsoSel);
        const generatedAt = moment();
        const completed = scadenzeCorsi.filter(isCompleted).length;
        const expired = scadenzeCorsi.filter(isExpired).length;
        const inProgress = scadenzeCorsi.length - completed - expired;
        const collator = new Intl.Collator('it', {
            sensitivity: 'base',
            numeric: true,
        });
        const reportRows = [...scadenzeCorsi].sort((first, second) => {
            const surnameComparison = collator.compare(
                first.surname || '',
                second.surname || ''
            );
            return surnameComparison !== 0
                ? surnameComparison
                : collator.compare(first.name || '', second.name || '');
        });
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a3',
        });

        doc.setProperties({
            title: `Rendicontazione e-learning ${corsoSel}`,
            subject: 'Stato di avanzamento dei partecipanti e-learning',
        });
        doc.setTextColor(17, 82, 111);
        doc.setFontSize(18);
        doc.text('Rendicontazione formazione e-learning', 14, 16);
        doc.setTextColor(35, 35, 35);
        doc.setFontSize(10);
        doc.text(
            `Corso: ${corsoSel} - ${selectedCourse?.Descrizione || ''}`,
            14,
            24
        );
        doc.setFontSize(8.5);
        doc.text(
            `Generato il: ${generatedAt.format('DD/MM/YYYY HH:mm')}`,
            14,
            30
        );
        doc.text(
            `Partecipanti: ${scadenzeCorsi.length}   Completati: ${completed}   In corso: ${inProgress}   Termine scaduto: ${expired}`,
            14,
            35
        );
        doc.autoTable({
            startY: 40,
            head: [
                [
                    'Azienda',
                    'Cognome',
                    'Nome',
                    'Codice fiscale',
                    'Matricola',
                    'Qualifica',
                    'Sesso',
                    'Iscrizione',
                    'Inizio',
                    'Completamento',
                    'Termine massimo',
                    'Avanzamento',
                    'Stato',
                    'ID iscrizione',
                ],
            ],
            body: reportRows.map((row) => [
                row.RagioneSociale || row.custom_b || '-',
                row.surname || '-',
                row.name || '-',
                row.CF || row.taxcode || '-',
                row.Matricola || '-',
                row.Qualifica || '-',
                row.Sesso || '-',
                formatPdfDate(row.date_subscribe),
                formatPdfDate(row.date_start),
                formatPigrecoCompletionDate(row.date_end),
                formatPdfDate(row.date_expire),
                `${Number(row.perc_course) || 0}%`,
                getStatusLabel(row),
                row.id || '-',
            ]),
            theme: 'grid',
            styles: {
                fontSize: 6.8,
                cellPadding: 1.5,
                valign: 'middle',
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [17, 82, 111],
                textColor: 255,
                fontStyle: 'bold',
            },
            alternateRowStyles: { fillColor: [244, 248, 250] },
            columnStyles: {
                0: { cellWidth: 37 },
                3: { cellWidth: 28 },
                5: { cellWidth: 28 },
                9: { cellWidth: 25 },
                12: { cellWidth: 23 },
            },
            didDrawPage: () => {
                const page = doc.internal.getCurrentPageInfo().pageNumber;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.setFontSize(7);
                doc.setTextColor(90);
                doc.text(
                    'Documento di supporto alla rendicontazione - dati estratti dal sistema Koala ASTM',
                    14,
                    pageHeight - 7
                );
                doc.text(`Pagina ${page}`, pageWidth - 14, pageHeight - 7, {
                    align: 'right',
                });
            },
        });

        const safeCode = corsoSel.replace(/[^a-z0-9_-]/gi, '_');
        doc.save(
            `rendicontazione_elearning_${safeCode}_${generatedAt.format('YYYYMMDD_HHmm')}.pdf`
        );
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                    sx={{ py: 1 }}
                >
                    <Grid item>
                        <GridToolbarQuickFilter placeholder="Cerca..." />
                    </Grid>
                    <Grid item>
                        <Tooltip title="Aggiungi tempo extra agli iscritti scaduti selezionati">
                            <span>
                                <Button
                                    size="small"
                                    variant="contained"
                                    startIcon={<MoreTime />}
                                    disabled={selectionModel.length === 0}
                                    onClick={openBulkExtraDays}
                                    sx={{
                                        textTransform: 'none',
                                        backgroundColor: '#2265B1',
                                    }}
                                >
                                    Tempo extra ({selectionModel.length})
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Esporta la rendicontazione PDF dei dati filtrati">
                            <span>
                                <Button
                                    size="small"
                                    variant="contained"
                                    startIcon={<PictureAsPdf />}
                                    onClick={exportPdf}
                                    disabled={
                                        !corsoSel || scadenzeCorsi.length === 0
                                    }
                                    sx={{
                                        textTransform: 'none',
                                        backgroundColor: '#11526F',
                                    }}
                                >
                                    Stampa Report
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={includiCessati}
                                    onChange={async (event) => {
                                        const nextIncludiCessati =
                                            event.target.checked;
                                        setIncludiCessati(nextIncludiCessati);
                                        if (corsoSel) {
                                            await statusOfCourse(
                                                corsoSel,
                                                nextIncludiCessati
                                            );
                                        }
                                    }}
                                    size="small"
                                />
                            }
                            label="Mostra cessati"
                            sx={{ mr: 0 }}
                        />
                    </Grid>
                    <Grid item>
                        {renderStatusSemaphore({
                            filterKey: 'completati',
                            title: 'Completati',
                            checkedIcon: <Circle />,
                            color: '#40C18F',
                        })}
                    </Grid>
                    <Grid item>
                        {renderStatusSemaphore({
                            filterKey: 'nonCompletati',
                            title: 'In corso',
                            checkedIcon: <Circle />,
                            color: '#FF2768',
                        })}
                    </Grid>
                    <Grid item>
                        {renderStatusSemaphore({
                            filterKey: 'termineScaduto',
                            title: 'Scaduti',
                            checkedIcon: <Warning />,
                            color: '#FF2768',
                        })}
                    </Grid>
                    <Grid item>
                        <Tooltip title="Mostra i non completati con termine entro i giorni indicati">
                            <Button
                                size="small"
                                variant={
                                    filtro.inScadenza ? 'contained' : 'outlined'
                                }
                                onClick={() => toggleFilter('inScadenza')}
                                sx={{
                                    textTransform: 'none',
                                    borderColor: '#11526F',
                                    color: filtro.inScadenza
                                        ? '#fff'
                                        : '#11526F',
                                    backgroundColor: filtro.inScadenza
                                        ? '#11526F'
                                        : '#fff',
                                    '&:hover': {
                                        borderColor: '#11526F',
                                        backgroundColor: filtro.inScadenza
                                            ? '#11526F'
                                            : '#f7f7f7',
                                    },
                                }}
                            >
                                Solo in scadenza entro
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                            }}
                        >
                            <Tooltip title="Diminuisci di 5 giorni">
                                <span>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            updateGiorniInScadenza(-5)
                                        }
                                        disabled={
                                            !filtro.inScadenza ||
                                            giorniInScadenza === 0
                                        }
                                        aria-label="Diminuisci giorni in scadenza"
                                    >
                                        <Remove />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <TextField
                                size="small"
                                label="Giorni"
                                value={giorniInScadenza}
                                disabled={!filtro.inScadenza}
                                inputProps={{
                                    readOnly: true,
                                    style: { textAlign: 'center' },
                                }}
                                sx={{ width: 90 }}
                            />
                            <Tooltip title="Aumenta di 5 giorni">
                                <span>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            updateGiorniInScadenza(5)
                                        }
                                        disabled={!filtro.inScadenza}
                                        aria-label="Aumenta giorni in scadenza"
                                    >
                                        <Add />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    </Grid>
                </Grid>
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        // è un loop qui carico i dati
        const fetchData = async () => {
            try {
                setLoading(false);
                let responsecorsiCliente = await unsplash.get('corsiCliente', {
                    params: { pigreco: 1 },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                });
                setCorsi(responsecorsiCliente.data.data);
            } catch (error) {
                console.error(error.message);
            }
        };

        fetchData();
    }, []);

    const handleShowSnack = (text, severity) => {
        setSnack({
            severity: severity,
            messaggio: text,
        });
        setOpenSnack(true);
    };

    const handleChangeCorsiSel = async (event, corso) => {
        const codiceCorso = corso?.Codice || '';
        setCorsiSel(codiceCorso);

        if (!codiceCorso) {
            setCorsoSel(null);
            setScadenzeCorsi([]);
            setScadenzeCorsiBackup([]);
            setSelectionModel([]);
            return;
        }

        setSelectionModel([]);
        await statusOfCourse(codiceCorso, includiCessati);
    };

    const statusOfCourse = async (
        corso,
        shouldIncludeCessati = includiCessati
    ) => {
        setLoading(true);
        setCorsoSel(corso);
        try {
        let response = await unsplash.post(
            'pigreco/statusForCourse',
            {
                corso: corso,
                includiCessati: String(shouldIncludeCessati),
            }, // tipologiaCorso: props.corsoH },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            }
        );
        if (response.data) {
            const taxcodes = response.data
                .map((item) => normalizeTaxCode(item?.taxcode))
                .filter(Boolean);
            let responseLavoratori = await unsplash.post(
                'lavoratori/match-details',
                { taxcodes },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            const lavoratori = responseLavoratori.data.data;
            const lavoratoriByCf = lavoratori.reduce((map, lavoratore) => {
                const normalizedCf = normalizeTaxCode(lavoratore?.CF);
                if (!normalizedCf) {
                    return map;
                }

                const existing = map.get(normalizedCf) || [];
                existing.push(lavoratore);
                map.set(normalizedCf, existing);
                return map;
            }, new Map());
            const rows = response.data.map((el) => {
                const lavoratore = pickLavoratoreDetails(lavoratoriByCf, el);
                return {
                    ...el,
                    ...lavoratore,
                };
            });
            setScadenzeCorsiBackup(rows);
            setScadenzeCorsi(getFilteredRows(rows, filtro, giorniInScadenza));
        } else {
            const rows = [];
            setScadenzeCorsi(rows);
            setScadenzeCorsiBackup(rows);
        }
        } catch (error) {
            setScadenzeCorsi([]);
            setScadenzeCorsiBackup([]);
            setSelectionModel([]);
            handleShowSnack('Impossibile caricare lo stato dei corsi e-learning. Riprova tra poco.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid item xs={12}>
                <Card>
                    <CardContent>
                        <Grid
                            container
                            spacing={2}
                            justifyContent="flex-start"
                            sx={{ mb: 1 }}
                        >
                            <Grid item xs={12} sm="auto">
                                <Autocomplete
                                    size="small"
                                    options={corsi}
                                    sx={{
                                        width: { xs: '100%', sm: 560 },
                                        '& .MuiOutlinedInput-root': {
                                            minHeight: 42,
                                            fontSize: 16,
                                            alignItems: 'center',
                                        },
                                        '& .MuiAutocomplete-input': {
                                            fontSize: 16,
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: 16,
                                        },
                                    }}
                                    value={
                                        corsi.find(
                                            (corso) => corso.Codice === corsiSel
                                        ) || null
                                    }
                                    onChange={handleChangeCorsiSel}
                                    getOptionLabel={(option) =>
                                        option
                                            ? `${option.Codice} - ${option.Descrizione}`
                                            : ''
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option.Codice === value.Codice
                                    }
                                    renderOption={(props, option) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <Box
                                                key={key}
                                                component="li"
                                                {...optionProps}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    gap: 0.25,
                                                }}
                                            >
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        fontWeight: 600,
                                                        lineHeight: 1.2,
                                                    }}
                                                >
                                                    {option.Codice}
                                                </Box>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        color: 'text.secondary',
                                                        fontSize: 13,
                                                        lineHeight: 1.25,
                                                        whiteSpace: 'normal',
                                                    }}
                                                >
                                                    {option.Descrizione}
                                                </Box>
                                            </Box>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Corso"
                                            placeholder="Cerca per codice o descrizione"
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Box
                            sx={{
                                height: { xs: '75vh', md: '60vh', xl: '75vh' },
                                width: 1,
                            }}
                        >
                            <DataGridPro
                                sx={{
                                    fontSize: 12,
                                    '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root':
                                        {
                                            color: '#fff !important',
                                        },
                                }}
                                components={{
                                    Toolbar: CustomToolbar,
                                    Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                }}
                                loading={loading}
                                localeText={
                                    itIT.components.MuiDataGrid.defaultProps
                                        .localeText
                                }
                                rows={scadenzeCorsi}
                                getRowId={(row) => row.id}
                                initialState={{
                                    pinnedColumns: {
                                        left: ['Actions', 'DataTermine'],
                                    },
                                }}
                                columns={columns}
                                pageSize={100}
                                disableSelectionOnClick
                                checkboxSelection
                                selectionModel={selectionModel}
                                onSelectionModelChange={(nextSelection) => {
                                    if (nextSelection.length > 200) {
                                        setSelectionModel(
                                            nextSelection.slice(0, 200)
                                        );
                                        handleShowSnack(
                                            'Selezione limitata alle prime 200 iscrizioni',
                                            'warning'
                                        );
                                        return;
                                    }
                                    setSelectionModel(nextSelection);
                                }}
                                isRowSelectable={(params) =>
                                    isExpired(params.row)
                                }
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            <BulkExtraDaysDialog
                open={bulkExtraDaysOpen}
                rows={selectedRows}
                loading={bulkExtraDaysLoading}
                result={bulkExtraDaysResult}
                onClose={closeBulkExtraDays}
                onConfirm={addBulkExtraDays}
            />
        </>
    );
};

const BulkExtraDaysDialog = ({
    open,
    rows,
    loading,
    result,
    onClose,
    onConfirm,
}) => {
    const [giorni, setGiorni] = useState(0);

    useEffect(() => {
        if (open) {
            setGiorni(0);
        }
    }, [open]);

    const parsedDays = Number.parseInt(giorni, 10) || 0;
    const newDeadline = moment()
        .startOf('day')
        .add(parsedDays, 'days')
        .format('DD/MM/YYYY');
    const failedResults = (result?.results || []).filter(
        (item) => !item.success
    );

    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>Aggiungi tempo extra massivamente</DialogTitle>
            <DialogContent dividers>
                <Typography sx={{ mb: 2 }}>
                    Iscrizioni selezionate: <strong>{rows.length}</strong>
                </Typography>
                <TextField
                    autoFocus
                    fullWidth
                    type="number"
                    label="Giorni extra"
                    value={giorni}
                    disabled={loading}
                    inputProps={{ min: 1, max: 365 }}
                    onChange={(event) => setGiorni(event.target.value)}
                    helperText={
                        parsedDays > 0
                            ? `PiGreco imposterà la nuova scadenza a oggi + ${parsedDays} giorni: ${newDeadline}`
                            : 'Inserire un valore tra 1 e 365 giorni'
                    }
                />
                {result && (
                    <Box
                        sx={{
                            mt: 2,
                            p: 1.5,
                            borderRadius: 1,
                            backgroundColor: failedResults.length
                                ? '#fff7ed'
                                : '#f0fdf4',
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                            Esito: {result.updated} aggiornati, {result.failed}{' '}
                            non aggiornati
                        </Typography>
                        <Typography
                            variant="caption"
                            component="div"
                            color="text.secondary"
                            sx={{ mb: failedResults.length ? 0.5 : 0 }}
                        >
                            ID operazione: {result.operationId}
                        </Typography>
                        {failedResults.map((item) => (
                            <Typography
                                key={item.id}
                                variant="caption"
                                component="div"
                                color="text.secondary"
                            >
                                {item.surname} {item.name}: {item.error}
                            </Typography>
                        ))}
                    </Box>
                )}
                <Box sx={{ mt: 2, maxHeight: 240, overflowY: 'auto' }}>
                    {rows.map((row) => (
                        <Box
                            key={row.id}
                            sx={{
                                py: 0.75,
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {row.surname} {row.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {row.taxcode || row.CF || '-'} · scaduto il{' '}
                                {moment(row.date_expire).format('DD/MM/YYYY')}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Annulla
                </Button>
                <Button
                    variant="contained"
                    startIcon={<MoreTime />}
                    disabled={
                        loading ||
                        rows.length === 0 ||
                        parsedDays < 1 ||
                        parsedDays > 365
                    }
                    onClick={() => onConfirm(parsedDays)}
                >
                    {loading ? 'Aggiornamento...' : 'Conferma tempo extra'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AndamentoELearning;

const PopUpGiorniCorsi = (props) => {
    const [open, setOpen] = React.useState(false);
    const [giorni, setGiorni] = useState(0);
    const [scadenza, setScadenza] = useState(null);
    const [scadenzaStart, setScadenzaStart] = useState(null);

    const active = !moment(props.row.date_expire).isBefore(moment(), 'day');

    const handleClickOpen = () => {
        setScadenzaStart(moment(props.row.date_expire).format('DD/MM/YYYY'));
        setScadenza(moment(props.row.date_expire).format('DD/MM/YYYY'));
        setGiorni(0);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleChangeGiorni = (e) => {
        //funzione per aggiungere giorni al corso selezionato
        const parsed = Number.parseInt(e.target.value, 10);
        const value = Number.isFinite(parsed) ? Math.max(parsed, 0) : 0;
        setGiorni(value);

        let dataGiorni = moment(
            value > 0 ? new Date() : scadenzaStart,
            'DD/MM/YYYY'
        ).add(value, 'days');

        setScadenza(dataGiorni.format('DD/MM/YYYY'));
    };

    const confirmExtraDays = async (e) => {
        try {
            //controlla se la data di scadenza e già passata(return false) oppure se deve scadere(return true)
            let from_today = moment(props.row.date_expire).isBefore(
                moment(),
                'day'
            );
            await unsplash.post(
                'pigreco/addDaysEmployee',
                {
                    giorni: giorni,
                    id_iscrizione: props.row.id,
                    from_today: from_today,
                }, // tipologiaCorso: props.corsoH },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            await props.statusOfCourse(props.corso);
            props.handleShowSnack(
                'Salvataggio avvenuto con successo',
                'success'
            );
        } catch (e) {
            console.log(e);
            props.handleShowSnack(
                "Errore durante l'aggiunta dei giorni",
                'error'
            );
        }
    };

    return (
        <div>
            <Tooltip
                title={
                    active
                        ? 'I giorni extra si possono aggiungere dopo la scadenza'
                        : 'Aggiungi giorni extra'
                }
            >
                <span>
                    <IconButton
                        disabled={active}
                        aria-label="edit"
                        onClick={handleClickOpen}
                    >
                        <MoreTime
                            style={{
                                height: '2rem',
                                width: '2rem',
                                color: '#2265B1',
                                opacity: active ? '50%' : '100%',
                            }}
                        />
                    </IconButton>
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'sm'}
                TransitionComponent={Transition}
            >
                <DialogTitle
                    sx={{
                        paddingTop: '10px',

                        textAlign: 'center',
                    }}
                >
                    Aggiungi giorni
                </DialogTitle>
                <DialogContent dividers={false}>
                    <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                        <Grid item xs={12}>
                            <TextField
                                value={giorni}
                                name="Giorniextra"
                                label="Giorni extra"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => handleChangeGiorni(e)}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                disabled
                                value={scadenza}
                                name="DataTermine"
                                label="Data Termine"
                                type="text"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        px: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Chiudi
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        disabled={!giorni || giorni <= 0}
                        onClick={confirmExtraDays}
                    >
                        Salva giorni extra
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
